<template>
    <div class="switch" :class="{'switch--on': value, 'switch--disabled': disabled}" @click="toggle()">
        <div class="switch__knob" :class="{'switch__knob--on': value}"></div>
    </div>

</template>

<script>

    export default {
        name: "lightswitch",
        props: {
            value: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            direction: {type: String, default: "horizontal"},
        },
        methods: {
            toggle() {
                if (!this.disabled) {
                    this.$emit('input', !this.value)
                }
            }
        }

    }
</script>

<style lang="scss">
    .switch {
        cursor: pointer;
        position: relative;
        background-color: #DDD;
        width: 3em;
        height: 1.5em;
        border-radius: 1.5em;


        &--disabled {
            cursor: not-allowed;
            opacity: .3;
            background-color: #AAA;
        }

        &--on {
            background-color: #1cd800;
        }


        &__knob {
            position: absolute;
            top: .1em;
            left: .1em;
            width: 1.3em;
            height: 1.3em;
            border-radius: 1.4em;
            background-color: white;
            transition: all 0.3s ease;
            box-shadow: 0 0.1em 0.1em 0 rgba(0, 0, 0, 0.1);
        }

        &__knob--on {
            left: 1.6em;

        }
    }


</style>